import { Star, Quote } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "@/components/ui/carousel";
import { Reveal } from "@/components/shared/Reveal";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { useLanguage } from "@/context/LanguageContext";
import { CONTENT } from "@/i18n/content";

function initials(name) {
  return name
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("");
}

function TestimonialCard({ item }) {
  return (
    <div className="flex h-full flex-col rounded-3xl border border-navy/8 bg-white p-7 shadow-[0_2px_20px_-8px_rgba(15,27,61,0.08)]">
      <Quote className="h-7 w-7 text-gold/40" />
      <div className="mt-3 flex gap-0.5">
        {Array.from({ length: item.rating }).map((_, i) => (
          <Star key={i} className="h-4 w-4 fill-gold text-gold" />
        ))}
      </div>
      <p className="mt-4 flex-1 text-sm leading-relaxed text-navy/80">{`\u201C${item.text}\u201D`}</p>
      <div className="mt-6 flex items-center gap-3 border-t border-navy/8 pt-5">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy font-heading text-sm font-semibold text-gold">
          {initials(item.name)}
        </span>
        <div>
          <p className="text-sm font-semibold text-navy">{item.name}</p>
          <p className="text-xs text-navy/55">
            {item.role} • {item.city}
          </p>
        </div>
      </div>
    </div>
  );
}

export function Testimonials() {
  const { lang } = useLanguage();
  const t = CONTENT[lang].testimonials;

  return (
    <section className="bg-ivory py-20 sm:py-28" data-testid="testimonials">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading eyebrow={t.eyebrow} title={t.title} />

        <Reveal delay={120} className="mt-14">
          <Carousel opts={{ align: "start", loop: true }} className="w-full">
            <CarouselContent className="-ml-4">
              {t.items.map((item, i) => (
                <CarouselItem key={i} className="basis-full pl-4 md:basis-1/2 lg:basis-1/3" data-testid={`testimonial-${i}`}>
                  <TestimonialCard item={item} />
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="mt-8 flex items-center justify-center gap-3">
              <CarouselPrevious className="static translate-y-0 border-navy/20 text-navy hover:bg-navy hover:text-cream" data-testid="testimonial-prev" />
              <CarouselNext className="static translate-y-0 border-navy/20 text-navy hover:bg-navy hover:text-cream" data-testid="testimonial-next" />
            </div>
          </Carousel>
        </Reveal>
      </div>
    </section>
  );
}
